"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIGHTTYPE = void 0;
var LIGHTTYPE;
(function (LIGHTTYPE) {
    LIGHTTYPE["AMBIENT"] = "ambient";
    LIGHTTYPE["DIRECTIONAL"] = "directional";
    LIGHTTYPE["HEMISPHERE"] = "hemisphere";
    LIGHTTYPE["POINT"] = "point";
    LIGHTTYPE["RECTANGLE"] = "rectangle";
    LIGHTTYPE["SPOT"] = "spot";
})(LIGHTTYPE = exports.LIGHTTYPE || (exports.LIGHTTYPE = {}));
//# sourceMappingURL=ILight.js.map